import styled, { createGlobalStyle } from 'styled-components'

export const MoveableHandleStyles = createGlobalStyle`
  .moveable-direction.moveable-nw,
  .moveable-direction.moveable-ne,
  .moveable-direction.moveable-sw,
  .moveable-direction.moveable-se {
    width: 12px !important;
    height: 12px !important;
    margin-top: -6px !important;
    margin-left: -6px !important;
    background-color: white !important;
    border-color: #387DFF !important;
  }

  .moveable-line.moveable-guideline {
    background: #ff3366 !important;
    opacity: 0.7;
  }
`

export const LayerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
`

export const ItemFrame = styled.div.attrs<{
  $left: number
  $top: number
  $width: number
  $height: number
  $zIndex: number
  $rotation: number
  $flipX: boolean
  $isActive: boolean
  $isMovableVisible: boolean
  $isSelectionChromeVisible: boolean
}>(({ $left, $top, $width, $height, $zIndex, $rotation, $flipX }) => ({
  style: {
    left: `${$left}px`,
    top: `${$top}px`,
    width: `${$width}px`,
    height: `${$height}px`,
    zIndex: $zIndex,
    transform: `rotate(${$rotation}deg) scaleX(${$flipX ? -1 : 1})`
  }
}))`
  position: absolute;
  cursor: ${({ $isActive, $isMovableVisible, $isSelectionChromeVisible }) =>
    !$isMovableVisible
      ? 'default'
      : $isActive && $isSelectionChromeVisible
        ? 'move'
        : 'pointer'};
  outline: ${({ $isSelectionChromeVisible }) =>
    $isSelectionChromeVisible ? '2px solid #387DFF' : '2px solid transparent'};
  &:hover {
    outline-color: ${({ $isMovableVisible }) =>
      $isMovableVisible ? '#387dff' : 'transparent'};
  }
`
